<template>
  <ficon type="info-circle" class="text-info"></ficon>
</template>
<script lang="ts">
export default {}
</script>
